import './PageSpinnerStyles.css';

const PageSpinner = () => {
    return (
        <div className="loading"></div>
    )
}

export default PageSpinner;